import React, { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Box, Button, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

const getRangeDate = (value) => {
  if (!value) {
    return new Date();
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? new Date() : parsedDate;
};

const CustomDateRange = (props) => {
  const datePickerRef = useRef(null);
  const useModal = Boolean(props.useModal);
  const usePopover = Boolean(props.usePopover);
  const [state, setState] = useState([
    {
      startDate: getRangeDate(props.range?.startDate),
      endDate: getRangeDate(props.range?.endDate),
      key: "selection",
    },
  ]);

  useEffect(() => {
    if (useModal || usePopover) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target) &&
        props.setShowDatePicker
      ) {
        props.setShowDatePicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props.setShowDatePicker, useModal, usePopover]);

  useEffect(() => {
    if (props.range?.startDate || props.range?.endDate) {
      setState([
        {
          startDate: getRangeDate(props.range?.startDate),
          endDate: getRangeDate(props.range?.endDate),
          key: "selection",
        },
      ]);
    }
  }, [props.range?.startDate, props.range?.endDate]);

  useEffect(() => {
    if (props.setFrequency) {
      props.setFrequency("Custom Date");
    }
  }, [props.setFrequency]);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const closeDatePicker = () => {
    if (props.setShowDatePicker) {
      props.setShowDatePicker(false);
    }
  };

  const handleFetchData = async () => {
    const { startDate, endDate } = state[0];
    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    if (props.setFrequency) {
      props.setFrequency("Custom Date");
    }

    try {
      if (props.onFetch) {
        await props.onFetch({
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        });
        closeDatePicker();
        return;
      }

      const response = await axios.get(
        `get-source-table-summary/?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
      );
      const sortedData = response.data.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      props.setHistoryData(sortedData);
      closeDatePicker();
    } catch (error) {
      console.log(error);
    }
  };

  const pickerContent = (
    <>
      {useModal && (
        <IconButton
          onClick={closeDatePicker}
          sx={{
            position: "absolute",
            top: "8px",
            right: "8px",
            color: "#5f6b7a",
          }}
        >
          <CloseIcon sx={{ height: 18, width: 18 }} />
        </IconButton>
      )}
      <DateRangePicker
        onChange={(item) => setState([item.selection])}
        moveRangeOnFirstSelection={false}
        ranges={state}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          background: "white",
        }}
      >
        <Button
          sx={{
            background: "#0576FC",
            color: "white",
            marginBottom: "10px",
            marginRight: "10px",
          }}
          onClick={handleFetchData}
        >
          Fetch Data
        </Button>
      </div>
    </>
  );

  if (useModal) {
    return (
      <Modal
        open={Boolean(props.showDatePicker)}
        onClose={closeDatePicker}
        aria-labelledby="custom-date-range-modal"
        aria-describedby="custom-date-range-picker"
        disableAutoFocus
      >
        <Box sx={dateRangeModalStyles}>
          <div ref={datePickerRef}>{pickerContent}</div>
        </Box>
      </Modal>
    );
  }

  if (usePopover) {
    return (
      <Box sx={dateRangePopoverStyles} ref={datePickerRef}>
        {pickerContent}
      </Box>
    );
  }

  return (
    <div style={dateRangePickerStyles} ref={datePickerRef}>
      {pickerContent}
    </div>
  );
};

const dateRangePickerStyles = {
  position: "absolute",
  zIndex: 80,
  backgroundColor: "white",
  marginLeft: "-160px",
  marginTop: 0,
  boxShadow: "2px 2px 8px 0px rgba(0,0,0,0.30)",
};

const dateRangeModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#fff",
  borderRadius: "12px",
  boxShadow: 24,
  p: "12px",
  width: "fit-content",
  maxWidth: "95vw",
  maxHeight: "95vh",
  overflow: "auto",
};

const dateRangePopoverStyles = {
  bgcolor: "#fff",
  borderRadius: "8px",
  boxShadow: "2px 2px 8px 0px rgba(0,0,0,0.30)",
  overflow: "hidden",
};

export default CustomDateRange;
 
